import React, { useState } from 'react';
import { Button, useTheme, Menu, MenuItem } from '@mui/material';
import { DataGrid, GridToolbarContainer } from '@mui/x-data-grid';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import IconButton from '@mui/material/IconButton';
import GetAppIcon from '@mui/icons-material/GetApp';
import swal from "sweetalert";
import { CSVLink } from "react-csv";
import './CustomToolbar.css';  // Import the CSS file

const logo = '/assets/zamzamlogoBlack.png';

const CustomToolbar = ({ rows = [], columns = [], accountNumber, date_from, date_to }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isCSVExporting, setIsCSVExporting] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExportPDF = () => {
    if (!columns.length || !rows.length) {
      swal("Error", "There is nothing to print. Please filter your data.", "error");
      return;
    }

    const doc = new jsPDF();
    const img = new Image();
    img.src = logo;
    img.onload = () => {
      doc.addImage(img, 'PNG', 10, 10, 30, 15);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(16);
      doc.setTextColor(0, 0, 0);
      doc.text('ZamZam Bank Online', 50, 20);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(12);
      doc.text(`For Account Number ${accountNumber} From ${date_from} To ${date_to}.`, 50, 30);
      generatePDF(doc);
    };
    img.onerror = () => {
      generatePDF(doc);
    };

    const generatePDF = (doc) => {
      const tableColumn = columns.map(col => col.headerName);
      const tableRows = rows.map(row =>
        columns.map(col => row[col.field])
      );

      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 40,
        didDrawCell: (data) => {
          if (data.row.index === 0) {
            doc.setFillColor(0, 128, 131);
            doc.setTextColor(255, 255, 255);
          }
        },
        styles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          cellPadding: 4, // Increase cell padding
          fontSize: 9, // Adjust font size
        },
        headStyles: {
          fillColor: [0, 128, 131],
          textColor: [255, 255, 255],
          cellPadding: 4, // Increase cell padding for headers
        },
        margin: { top: 10 },
        rowPageBreak: 'auto',
        showHead: 'everyPage',
        theme: 'striped',
        tableLineColor: [0, 0, 0],
        tableLineWidth: 0.1,
      });

      doc.save(`For ${accountNumber} ${date_from}-${date_to}.pdf`);
    };
  };

  const handleExportCSV = (event) => {
    if (!columns.length || !rows.length) {
      event.preventDefault();
      swal("Error", "There is nothing to print. Please filter your data.", "error");
      return;
    }
    setIsCSVExporting(true);
  };

  const csvData = rows.map(row => {
    const rowData = {};
    columns.forEach(col => {
      rowData[col.headerName] = row[col.field];
    });
    return rowData;
  });

  return (
    <GridToolbarContainer>
      <Button color="primary" onClick={handleClick}>
        <IconButton aria-label="export">
          <GetAppIcon />
        </IconButton>
        Export
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleExportPDF}>Export PDF</MenuItem>
        <MenuItem>
          <CSVLink
            data={csvData}
            filename={`For ${accountNumber} ${date_from}-${date_to}.csv`}
            className="custom-csv-link"  // Apply the custom class
            onClick={handleExportCSV}
          >
            Export CSV
          </CSVLink>
        </MenuItem>
      </Menu>
    </GridToolbarContainer>
  );
};

export default CustomToolbar;
